import React, { useEffect, useState } from "react";
import "./DashboardSideBar.scss";
import {
  FiMenu,
  FiTrello,
  FiChevronRight,
  FiHeart,
  FiUsers,
  FiMessageCircle,
  FiLogOut,
  FiBookOpen,
  FiEye,
  FiCalendar
} from "react-icons/fi";
import { Link, NavLink, useHistory } from "react-router-dom";
import { removeToken } from "../../../utils/authManager";
import { connect } from "react-redux";
import { fetchProfile } from "../../../store/profile/actions";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const DashboardSideBar = (props) => {
  const history = useHistory();
  const [open, setOpen] = React.useState(true);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const resizeScreen = () =>{
    console.log(window.innerWidth);
  }
  useEffect(() => {
    props.fetchProfile();
    window.addEventListener("resize", resizeScreen());
  }, []);
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const menu = [
    {
      route: "/dashboard",
      name: "Dashboard",
      icon: <FiTrello className="mr-3" />,
    },
    {
      route: "/courses",
      name: "Courses",
      icon: <FiBookOpen className="mr-3" />,
    },
    {
      route: "/upcoming-classes",
      name: "Upcoming Classes",
      icon: <FiCalendar className="mr-3" />,
    },
    {
      route: "/followers",
      name: "Contacts list",
      icon: <FiHeart className="mr-3" />,
    },
    {
      route: "/following",
      name: "Following",
      icon: <FiUsers className="mr-3" />,
    },
    {
      route: "/chat",
      name: "Chat",
      icon: <FiMessageCircle className="mr-3" />,
    },
    {
      route: "/signup",
      name: "Log Out",
      icon: <FiLogOut className="mr-3" />,
      logOutBtn: true,
    },
  ];
  const handleLogout = () => {
    removeToken();
    history.push("/");
  };
  useEffect(() => {
   if(windowDimensions.width < 1432){
    setOpen(false)
   }else{
    setOpen(true)
   }
  }, [windowDimensions])

  return (
    Object.keys(props.profile).length ?
      (
          <div className={`dashboard-sidebar ${open}`}>
            <div
              className="menu"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <FiMenu className="text-white h4 m-0" />
            </div>
            <Link className="brand" to="/" style={{ textDecoration: "none" }}>
              <img src="/images/logo/logo-white.png" alt="logo" className="logo" />
              <div className="h5">Demo Company</div>
            </Link>
            <div className="top">
              <img src="/images/bg/pp.png" alt="" className="top-img" />
              <div className="detail">
                <div className="name"> {props.profile.name} </div>
                <div className="email"> {props.profile.email} </div>
                <Link to="/profile" className="btn btn-outline-light  ">
                  <span className="false-d-none">View Profile</span>
                  <FiEye className="false-d-visible" />
                </Link>
              </div>
            </div>
      
            <div className="middle">
              {menu.map((item, i) => {
                // if(item.name === "Upcoming classes" && props.profile.role !== "TEACHER"){
                //   item = null
                // }
                // const showCalendar = item.name === "Upcoming classes" && props.profile.role === "TEACHER" ? item : null;
                if (item?.logOutBtn) {
                  return (
                    <div
                      className="link"
                      onClick={() => {
                        handleLogout();
                      }}
                      style={{ cursor: "pointer" }}
                      key={i}
                    >
                      <div className="d-flex justify-content-md-start align-items-center">
                        {item?.icon}{" "}
                        <span className="false-d-none"> {item?.name} </span>
                      </div>
                      <div className="arrow false-d-none">
                        <FiChevronRight className="icon h3" />
                      </div>
                    </div>
                  );
                } else {
                  return (
                    item ? 
                    (
                      <NavLink to={`${item?.route}`} className="link" key={i}>
                        <div className="d-flex justify-content-md-start align-items-center">
                          {item?.icon}
                          <span className="false-d-none"> {item?.name} </span>
                        </div>
                        <div className="arrow false-d-none">
                          <FiChevronRight className="icon h3" />
                        </div>
                      </NavLink>
                    ) : null
                  );
                }
              })}
            </div>
      
            <div className="bottom false-d-none">© 2020, Demo Company</div>
          </div>
      ): null
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile.profile,
});
export default connect(mapStateToProps, {
  fetchProfile,
})(DashboardSideBar);
